/*
 * @Description: 地图样式选择（纯净 / 普通 / 卫星）。
 *   卡片式下拉，放在底部时间轴/播放条最左侧；驾驶舱与回放页共用。
 */
import React from 'react'
import { Dropdown } from 'antd'
import { DownOutlined, EnvironmentOutlined } from '@ant-design/icons'
import { CockpitMapStyle, MAP_STYLE_OPTIONS } from '../../constants'
import './index.scss'

interface MapStyleSelectProps {
  value: CockpitMapStyle
  onChange: (value: CockpitMapStyle) => void
}

const MapStyleSelect: React.FC<MapStyleSelectProps> = ({ value, onChange }) => {
  const current =
    MAP_STYLE_OPTIONS.find((o) => o.value === value) || MAP_STYLE_OPTIONS[0]

  const menu = {
    selectedKeys: [value],
    items: MAP_STYLE_OPTIONS.map((o) => ({ key: o.value, label: o.label })),
    onClick: ({ key }: { key: string }) => onChange(key as CockpitMapStyle)
  }

  return (
    <Dropdown menu={menu} trigger={['click']} placement="topLeft">
      <div className="map-style-select">
        <EnvironmentOutlined className="map-style-select__icon" />
        <span className="map-style-select__label">{current.label}</span>
        <DownOutlined className="map-style-select__arrow" />
      </div>
    </Dropdown>
  )
}

export default MapStyleSelect
